import { h, resolveComponent } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout'

const routes = [
  //For Login
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login/Login.vue')
  },

  //For Activate
  {
    path: '/activate/:number?',
    name: 'Activate',
    component: () => import('@/views/Login/Activate.vue')
  },

  //For Reset
  {
    path: '/reset',
    name: 'Reset',
    component: () => import('@/views/Login/Reset.vue')
  },

  //For OTP
  {
    path: '/otp',
    name: 'OTP',
    component: () => import('@/views/Login/OTP.vue')
  },

  //For Dashboard
  {
    path: '/',
    name: 'Home',
    component: DefaultLayout,
    redirect: '/login',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard/Dashboard.vue')
      }
    ]
  },

  //For Terminal
  {
    path: '/terminal',
    name: 'Terminal',
    component: DefaultLayout,
    redirect: '/terminal',
    beforeEnter(to, from, next) {
      if (
        JSON.parse(sessionStorage.getItem('permissionsData'))
          .terminalPermissions.length > 0
      ) {
        next()
      } else {
        router.go(-1)
      }
    },
    children: [
      {
        path: '/terminal',
        name: 'terminal',
        component: () => import('@/views/Terminal/Terminal.vue')
      },

      {
        path: '/terminal/add',
        name: 'AddTerminal',
        beforeEnter(to, from, next) {
          if (
            JSON.parse(
              sessionStorage.getItem('permissionsData')
            ).terminalPermissions.includes('Add')
          ) {
            next()
          } else {
            router.go(-1)
          }
        },
        component: () => import('@/views/Terminal/AddTerminal.vue')
      },
      {
        path: '/terminal/view/:outletId/:terminalId',
        name: 'ViewTerminal',
        beforeEnter(to, from, next) {
          if (
            JSON.parse(
              sessionStorage.getItem('permissionsData')
            ).terminalPermissions.includes('View')
          ) {
            next()
          } else {
            router.go(-1)
          }
        },
        component: () => import('@/views/Terminal/ViewTerminal.vue')
      },
      {
        path: '/terminal/edit/:outletId/:terminalId',
        name: 'EditTerminal',
        beforeEnter(to, from, next) {
          if (
            JSON.parse(
              sessionStorage.getItem('permissionsData')
            ).terminalPermissions.includes('Edit')
          ) {
            next()
          } else {
            router.go(-1)
          }
        },
        component: () => import('@/views/Terminal/EditTerminal.vue')
      }
    ]
  },

  //For Analytics Report
  {
    path: '/analyticsReport',
    name: 'AnalyticsReport',
    component: DefaultLayout,
    redirect: '/analyticsReport',
    children: [
      {
        path: '/analyticsReport',
        name: 'analyticsReport',
        component: () => import('@/views/Analytics/AnalyticsReport.vue')
      }
    ]
  },

  //For Operator
  {
    path: '/operator',
    name: 'Operator',
    component: DefaultLayout,
    redirect: '/operator',
    beforeEnter(to, from, next) {
      if (
        JSON.parse(sessionStorage.getItem('permissionsData'))
          .operatorPermissions.length > 0
      ) {
        next()
      } else {
        router.go(-1)
      }
    },
    children: [
      {
        path: '/operator',
        name: 'operator',
        component: () => import('@/views/Operator/Operator.vue')
      },

      {
        path: '/operator/add',
        name: 'AddOperator',
        beforeEnter(to, from, next) {
          if (
            JSON.parse(
              sessionStorage.getItem('permissionsData')
            ).operatorPermissions.includes('Add')
          ) {
            next()
          } else {
            router.go(-1)
          }
        },
        component: () => import('@/views/Operator/AddOperator.vue')
      },
      {
        path: '/operator/edit/:id',
        name: 'EditOperator',
        beforeEnter(to, from, next) {
          next()
        },
        component: () => import('@/views/Operator/EditOperator.vue')
      },

      {
        path: '/operator/changePIN',
        name: 'ChangePIN',
        component: () => import('@/views/Operator/ChangePIN.vue')
      }
    ]
  },

  //For Transactions
  {
    path: '/transactions',
    name: 'Transactions',
    component: DefaultLayout,
    redirect: '/transactions',
    children: [
      {
        path: '/transactions',
        name: 'transactions',
        component: () => import('@/views/Transactions/Transactions.vue')
      }
    ]
  },

  //For Advice
  {
    path: '/advice',
    name: 'Advice',
    component: DefaultLayout,
    redirect: '/advice',
    children: [
      {
        path: '/advice',
        name: 'advice',
        component: () => import('@/views/Advice/Advice.vue')
      }
    ]
  },

  //For Download QR
  {
    path: '/downloadQR',
    name: 'DownloadQR',
    component: DefaultLayout,
    redirect: '/advice',
    children: [
      {
        path: '/downloadQR',
        name: 'downloadQR',
        component: () => import('@/views/DownloadQR/DownloadQR.vue')
      }
    ]
  },

  //For Merchant Information
  {
    path: '/viewMerchantInformation',
    name: 'ViewMerchantInformation',
    component: DefaultLayout,
    redirect: '/viewMerchantInformation',
    beforeEnter(to, from, next) {
      next()
    },
    children: [
      {
        path: '/viewMerchantInformation',
        name: 'viewMerchantInformation',
        component: () =>
          import('@/views/MerchantInformation/ViewMerchantInformation.vue')
      },
      {
        path: '/merchant/edit',
        name: 'EditMerchant',
        beforeEnter(to, from, next) {
          next()
        },
        component: () => import('@/views/MerchantInformation/EditMerchant.vue')
      },
      {
        path: '/outlet/edit/:id',
        name: 'EditOutlet',
        beforeEnter(to, from, next) {
          next()
        },
        component: () => import('@/views/MerchantInformation/EditOutlet.vue')
      }
    ]
  },

  //For Activity Log
  {
    path: '/activity-log',
    name: 'ActivityLog',
    component: DefaultLayout,
    redirect: '/activity-log',
    children: [
      {
        path: '/activity-log',
        name: 'activityLog',
        component: () => import('@/views/ActivityLog/ActivityLog.vue')
      }
    ]
  },

  // for other pages
  {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      }
    },
    children: [
      {
        path: '404',
        name: 'Page404',
        component: () => import('@/views/pages/Page404')
      },
      {
        path: '500',
        name: 'Page500',
        component: () => import('@/views/pages/Page500')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  }
})

export default router
